<template>
  <div class="emptyLayoutContainer wrapper appWrapper">
    <c-errors></c-errors>
    <router-view class="viewContainer" id="routerViewport"></router-view>
  </div>
</template>

<script>
export default {}
</script>
